import React from 'react'
import Text from 'src/Components/shared/Text'

const Strong = restProps => <Text element='span' weight='bold' {...restProps} />

export default Strong
